export default {
  en: {
    supplementType: 'Supplement Type',
    name: 'Name',
    keyword: 'Keyword',
    newSupplementType: 'New Supplement Type',
    confirmRemoveSupplementTypeTitle: 'Confirm',
    confirmRemoveSupplementTypeMessage: 'Confirm to delete <strong>{supplementTypeName}</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    removeSupplementTypeSuccess: 'Delete supplement Type success'
  },
  th: {
    supplementType: 'รายการเพิ่มเติม',
    name: 'ชื่อ',
    keyword: 'คำที่ต้องการค้นหา',
    newSupplementType: 'สร้างรายการเพิ่มเติม',
    confirmRemoveSupplementTypeTitle: 'ยืนยัน',
    confirmRemoveSupplementTypeMessage: 'กรุณายืนยันการลบ <strong>{supplementTypeName}</strong>',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    removeSupplementSuccess: 'ลบประเภทรายการเพิ่มเติมสำเร็จ'
  }
}
